// src/components/Admin/Auth/LoginForm/LoginForm.js
import React, { useState } from "react";
import { Form, Dimmer, Loader } from "semantic-ui-react";
import { useFormik } from "formik";
import { Auth, User } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./LoginForm.form";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import "./LoginFormPartner.scss"; // Asegúrate de tener el CSS correspondiente

const authController = new Auth();
const userController = new User();

export function LoginFormPartner() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Decide la ruta tras /portal/ según rol/account
  const getPortalPath = (user) => {
    const { role, account } = user;
    if (role === "teacher" && account === "free") {
      return "teacherfree/salas";
    } else if (role === "teacher") {
      return "teacher/salas";
    }
    return "";
  };



  // 2) Login “normal” por formulario
  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValues) => {
      try {
        setLoading(true);
        const result = await authController.login(formValues);
        const data = result.data ?? result;
        const accessToken = data.access;
        const refreshToken = data.refresh;

        if (!accessToken || !refreshToken) {
          throw new Error("Respuesta de login inválida: faltan tokens");
        }

        authController.setAccessToken(accessToken);
        authController.setRefreshToken(refreshToken);

        const userData = await userController.getMe(accessToken);
        await login(accessToken, userData);

        const portalPath = getPortalPath(userData);
        navigate(`/${portalPath}`, { replace: true });
      } catch (error) {
        setLoading(false);
        toast.error(error.message || "Login fallido", {
          position: "top-center",
          autoClose: false,
        });
      }
    },
  });

  return (
    <>
      <ToastContainer />
      {loading && (
        <Dimmer active inverted page>
          <Loader content="Cargando..." />
        </Dimmer>
      )}
      <Form onSubmit={formik.handleSubmit}>
        <Form.Input
          type="text"
          icon="user"
          iconPosition="left"
          name="email"
          placeholder="Correo electrónico"
          onChange={formik.handleChange}
          value={formik.values.email}
          error={formik.errors.email}
        />
        <Form.Input
          type="password"
          icon="lock"
          iconPosition="left"
          name="password"
          placeholder="Contraseña"
          onChange={formik.handleChange}
          value={formik.values.password}
          error={formik.errors.password}
        />
        <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
          Iniciar sesión
        </Form.Button>
        {/* Enlace para recuperar contraseña */}
        <div className="forgot-link">
          <Link to="/recuperar-contraseña" className="link-btn">
            ¿Has olvidado tu contraseña?
          </Link>
        </div>
        
      </Form>
    </>
  );
}
